(function(window, angular){'use strict';

var ngModule = angular.module('pp.services.auth', ['pp.services.core', 'pp.services.investor', 'pp.services.preference', 'pp.services.window']);

var EMAIL_REGEXP = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;
//This is the backend regex: (?:(?:\r\n)?[ \t])*(?:(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*)|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*:(?:(?:\r\n)?[ \t])*(?:(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*)(?:,\s*(?:(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*|(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)*\<(?:(?:\r\n)?[ \t])*(?:@(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*(?:,@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*)*:(?:(?:\r\n)?[ \t])*)?(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|"(?:[^\"\r\\]|\\.|(?:(?:\r\n)?[ \t]))*"(?:(?:\r\n)?[ \t])*))*@(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*)(?:\.(?:(?:\r\n)?[ \t])*(?:[^()<>@,;:\\".\[\] \000-\031]+(?:(?:(?:\r\n)?[ \t])+|\Z|(?=[\["()<>@,;:\\".\[\]]))|\[([^\[\]\r\\]|\\.)*\](?:(?:\r\n)?[ \t])*))*\>(?:(?:\r\n)?[ \t])*))*)?;\s*)

var API_BASE_PATH = '/feapi/r1';
var API_CONTENT_TYPE = 'application/vnd.propertypartner.feapi.auth.v1+json';
var API_LOGIN_ENDPOINT = '/auth/login';
var API_SIGNUP_ENDPOINT = '/auth/signup';
var API_NEWSLETTER_SIGNUP_ENDPOINT = '/newsletter/signup';
var API_LOGOUT_ENDPOINT = '/logout';
var API_AUTH_METHOD_ENDPOINT = '/auth/secondary';
var API_AUTH_HEARTBEAT_ENDPOINT = '/investor/time-left';
var API_TOKEN_INFO = '/auth/tokens/';
var API_REQUEST_NEW_TOKEN = '/auth/tokens?token=';
var SESSION_EXPIRED_PATH_BASE = '/login#/';
var SESSION_EXPIRED_HASH_KEY = 'pp-se';

var ONE_MINUTE_MILLIS = 60000;
var HEARTBEAT_RETRY_MS = 2000;
var HEARTBEAT_RETRIES = 5;

var PREFERENCE_KEY_COMPANY_NAME = 'investor.company-name';
var PREFERENCE_KEY_INDIVIDUAL_NAME = 'investor.individual-name';

/**
 * @ngdoc service
 * @name authService
 *
 * @description
 * Provides methods to invoke the FEAPI `/auth` endpoints.
 */
ngModule.service('authService', ['$http', '$q', '$timeout', '$window', 'ppTrack', 'investorService', 'preferenceService', 'windowService', function ($http, $q, $timeout, $window, track, investorService, preferenceService, windowService) {

    var promiseCache = {};

    var heartBeatErrorCounter = 0;

    var bindings = {};

    var api = {};

    var authHooks = [];

    var heartbeatStarted = false;

    /**
     * @ngdoc method
     * @name authService#login
     *
     * @description
     * Attempts to authenticate a user and if successful returns a cookie in the response headers
     * that establishes the authenticated session.
     *
     * Example request:
     * ```
     * {
     *   principal: '<STRING>',
     *   credentials: {
     *     password: <STRING>,
     *     code: <STRING>
     *   }
     * }
     * ```
     *
     * Success response:
     * ```
     * {
     *   email: '<STRING>'
     * }
     * ```
     *
     * @param {string} principal
     * @param {string} password
     * @param {object} pin {
        first:
        second:,
        third:,
        fourth:,
        fifth:,
        sixt:
     }
     * @param {string} code
     * @param {boolean} rememberMfa
     * @returns {Promise}
     */

    api.login = function (principal, password, pin, code, rememberMfa) {

        var endpoint = API_BASE_PATH + API_LOGIN_ENDPOINT;
        var payload = {
            principal: principal,
            credentials: {
                password: password
            }
        };

        if (pin) {
            payload.credentials.pin = pin;
        }

        if (code && code.length === 6) {
            payload.credentials.mfa = {
                totp: Number(code),
                rememberMe: !!rememberMfa
            };
        }

        var options = {};
        options.headers = {
            'Content-type': API_CONTENT_TYPE
        };

        return $http.post(endpoint, payload, options).then(function (response) {
            investorService.purgeCache();
            return investorService.getInvestor().then(function () {
                return {
                    success: true
                };
            });
        }, function (error) {
            switch (error.status) {
            case 400: // 'auth.login.validation' (not handled, treated as auth.error.unexpected)
            case 422: // 'auth.login.denied' OR 'auth.login.locked'
                return $q.reject({
                    reason: error.data.code,
                    details: error.data.details

                });
            case 499: // 'mfa.token.required' OR 'pin.setup.required' OR 'pin.required' WITH details: { type: 'pin', value: {'first': '', 'second': '', 'third': ''}}
                return $q.reject({
                    reason: error.data.code,
                    details: error.data.details
                });
            default:
                return $q.reject({
                    reason: 'auth.error.unexpected'
                });
            }
        });
    };

    /**
     * @ngdoc method
     * @name authService#signup
     *
     * @description
     * registers a new user and upon doing so successfully logs the user in.
     *
     * Example request:
     * ```
     * {
     *   email: <STRING>,
     *   password: <STRING>,
     *   firstName: <STRING>,
     *   lastName: <STRING>,
     *   grecaptchaResponse: <STRING>
     * }
     * ```
     *
     * Success response:
     * ```
     * {
     *   email: '<STRING>'
     * }
     * ```
     *
     * Error response:
     * ```
     * {
     *   code: '<STRING>',
     *   message: '<STRING>',
     *   details: [{
     *     kind: '<STRING>'
     *     field: '<STRING>'
     *     code: '<STRING>'
     *     message: '<STRING>'
     *   }]
     * }
     * ```
     *
     * @param {string} email
     * @param {string} password
     * @param {object} pin {
        first: ,
        third:,
        fourth:
     }
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} phoneNumber
     * @param {string} grecaptchaResponse
     * @returns {Promise}
     */

    // DO NOT USE OUTSIDE AUTH SERVICE, function public for testing and not to be called by components or directives
    api.signup = function (email, password, firstName, lastName, phoneNumber, recaptchaResponse) {

        var endpoint = API_BASE_PATH + API_SIGNUP_ENDPOINT;

        var payload = {
            email: email,
            password: password,
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber
        };

        if (recaptchaResponse) {
            payload.recaptchaResponse = recaptchaResponse;
        }

        var options = {};
        options.headers = {
            'Content-type': API_CONTENT_TYPE
        };

        return $http.post(endpoint, payload, options).then(function (response) {
            investorService.purgeCache();
            investorService.getUserInvestors();
            return investorService.getInvestor().then(function () {
                return {
                    success: true
                };
            });
        }, function (error) {
            switch (error.status) {
            case 400: // 'auth.login.validation' (not handled, treated as auth.error.unexpected)
            case 409: // 'auth.signup.exists'
                return $q.reject({
                    reason: error.data.code,
                });
            default: // 'auth.login.validation' or others
                return $q.reject({
                    reason: 'auth.error.unexpected'
                });
            }
        });
    };

    api.signupIndividual = function (email, password, firstName, lastName, phoneNumber, recaptchaResponse) {
        return api.signup(email, password, firstName, lastName, phoneNumber, recaptchaResponse).then(function () {
            var preferenceValue = firstName.trim() + ' ' + lastName.trim();
            return preferenceService.setPreference(PREFERENCE_KEY_INDIVIDUAL_NAME, preferenceValue).then(angular.noop, angular.noop);
        });
    };

    api.signupBusiness = function (companyName, email, password, firstName, lastName, phoneNumber, recaptchaResponse) {
        return api.signup(email, password, firstName, lastName, phoneNumber, recaptchaResponse).then(function () {
            var preferenceValue = companyName.trim();
            return preferenceService.setPreference(PREFERENCE_KEY_COMPANY_NAME, preferenceValue).then(angular.noop, angular.noop);
        });
    };

    /**
     * @ngdoc method
     * @name authService#emailSignup
     *
     * @description
     * Stores an email.
     *
     * Example request:
     * ```
     * {
     *   email: <STRING>
     * }
     * ```
     *
     * Success response:
     * ```
     * {
     *   email: '<STRING>'
     * }
     * ```
     *
     * Error response:
     * ```
     * {
     *   code: '<STRING>',
     *   message: '<STRING>',
     *   details: [{
     *     kind: '<STRING>'
     *     field: '<STRING>'
     *     code: '<STRING>'
     *     message: '<STRING>'
     *   }]
     * }
     * ```
     *
     * @param {string} email
     * @returns {Promise}
     */
    api.emailSignup = function (email, password, firstName, lastName, grecaptchaResponse) {

        var endpoint = API_BASE_PATH + API_NEWSLETTER_SIGNUP_ENDPOINT;
        var payload = {
            email: email
        };

        return $http.post(endpoint, payload).then(function (response) {
            return true;
        }, function (error) {
            switch (error.status) {
            case 400: // 'auth.login.validation' (not handled, treated as auth.error.unexpected)
            case 409: // 'auth.signup.exists'
                return $q.reject({
                    reason: error.data.code,
                });
            default: // 'auth.login.validation' or others
                return $q.reject({
                    reason: 'auth.error.unexpected'
                });
            }
        });
    };

    //Auto-logout

    api._getNextHeartbeat = function (timeRemaining) {
        return Math.round((timeRemaining - ONE_MINUTE_MILLIS) / 2);
    };

    function logoutAndReload() {
        api.logout().then(function () {
            if (bindings.logout) {
                bindings.logout();
            } else { // timeout
                var origin = windowService.getOrigin();
                $window.location.href = origin + SESSION_EXPIRED_PATH_BASE + SESSION_EXPIRED_HASH_KEY;
            }
        });
    }

    api.onLogout = function (logoutBinding) {
        if (!angular.isFunction(logoutBinding)) {
            return;
        }

        bindings.logout = logoutBinding;
    };

    /**
     * @ngdoc method
     * @name authService#logout
     *
     * @description
     * Forces a logout (expiration of the user session).
     *
     * Logout is called from endpoint: `/logout`.
     *
     * @returns {promise}
     */
    api.logout = function () {
        var endpoint = API_LOGOUT_ENDPOINT;
        return $http.get(endpoint);
    };

    /**
     * @ngdoc method
     * @name authService#getTokenInfo
     *
     * @description
     * Gets token expiry info
     *
     * @returns {promise}
     */
    api.getTokenInfo = function (token) {
        var endpoint = API_BASE_PATH + API_TOKEN_INFO + (token || '');
        return $http.get(endpoint);
    };

    /**
     * @ngdoc method
     * @name authService#requestNewToken
     *
     * @description
     * Requests a new token given an expired token
     *
     * @returns {promise}
     */
    api.requestNewToken = function (token) {
        var endpoint = API_BASE_PATH + API_REQUEST_NEW_TOKEN + token;
        return $http.post(endpoint).then(angular.noop, function (error) {
            return $q.reject({
                reason: error.data.code,
            });
        });
    };

    /**
     * @ngdoc method
     * @name authService#handleUnauthorised
     *
     * @description
     * Calls the logoutAndReload private function either with a mocked window object or
     * the angular $window object if the mock isn't defined. This is so we can mock the
     * window object in the unit tests
     *
     * Logout is called from endpoint: `/logout`.
     *
     */
    api.handleUnauthorised = function () {
        logoutAndReload();
    };

    /**
     * @ngdoc method
     * @name authService#heartBeat
     *
     * @description
     * Check to see how much time remains before user session expires,
     * Forces logout if within one minute of user session expiration.
     * Then reloads page.
     *
     * Loads data from: `/feapi/<VERSION>/investor/time-left`.
     * Data is loaded after timeout. Timeout is cached,
     * only one request per timeout period unless forceBeat is true.
     *
     * @param {number} nextHeartbeat
     * @param {boolean} forceBeat
     * @returns {promise}
     */
    api.getSessionTimeLeft = function () {

        var endpoint = API_BASE_PATH + API_AUTH_HEARTBEAT_ENDPOINT;

        return $http.get(endpoint).then(function (response) {
            return response.data.timeLeftInMillis;
        }, function (error) {
            return $q.reject({
                status: error.status
            });
        });
    };

    /**
     *
     * @description
     * Check to see how much time remains before user session expires,
     * Forces logout if within one minute of user session expiration.
     * Then reloads page.
     *
     * Loads data from: `/feapi/<VERSION>/investor/time-left`.
     * Data is loaded after timeout. Timeout is cached,
     * only one request per timeout period unless forceBeat is true.
     *
     * @param {number} nextHeartbeat
     * @param {boolean} forceBeat
     */
    function heartbeat(nextHeartbeatMillis) {

        function trackAndLogout() {
            track.deferEvent('logout.expired-session');
            api.handleUnauthorised();
        }

        $timeout(function () {
            api.getSessionTimeLeft().then(function (millisToExpiration) {
                heartBeatErrorCounter = 0;
                var nextHeartbeat = api._getNextHeartbeat(millisToExpiration);
                if (nextHeartbeat > 0) {
                    heartbeat(nextHeartbeat);
                } else {
                    trackAndLogout();
                }
            }, function (error) {
                switch (error.status) {
                case 401:
                    trackAndLogout();
                    break;
                default:
                    heartBeatErrorCounter++;
                    if (heartBeatErrorCounter > HEARTBEAT_RETRIES) {
                        trackAndLogout();
                    } else {
                        heartbeat(HEARTBEAT_RETRY_MS);
                    }
                }
            });
        }, nextHeartbeatMillis);
    }

    /**
     * @ngdoc method
     * @name authService#startHeartbeat
     *
     * @description
     * Starts the heartbeat recursive function with an initial call.
     * startHeartbeat can only call the heartbeat function once.
     *
     * @returns {boolean}
     */
    api.startHeartbeat = function () {
        if (!heartbeatStarted) {
            heartbeat(0);
            heartbeatStarted = true;
            return true;
        }
        return false;
    };

    /**
     * @ngdoc method
     * @name authService#getAuthMethods
     *
     * @description
     * Returns an array of authentication methods which the invesotr has enabled: e.g. ['pin', 'mfa'] etc.
     *
     * @returns {boolean}
     */
    api.getAuthMethods = function () {
        var endpoint = API_BASE_PATH + API_AUTH_METHOD_ENDPOINT;

        return $http.get(endpoint).then(function (response) {
            return response.data;
        }, function (error) {
            return $q.reject({
                status: error.status
            });
        });

    };

    /**
     * exposes the email regexp
     *
     * @property {RegExp}
     */
    api.emailRegexp = EMAIL_REGEXP;

    return api;
}]);
})(window, window.angular);